__turbopack_context__.v({
  "body": "Lbzu0W_body",
  "card": "Lbzu0W_card",
  "cta": "Lbzu0W_cta",
  "date": "Lbzu0W_date",
  "imageBadge": "Lbzu0W_imageBadge",
  "imageWrap": "Lbzu0W_imageWrap",
  "imageWrapMuted": "Lbzu0W_imageWrapMuted",
  "poster": "Lbzu0W_poster",
  "price": "Lbzu0W_price",
  "stickerBottomLeft": "Lbzu0W_stickerBottomLeft",
  "tagTopLeft": "Lbzu0W_tagTopLeft",
  "tagTopRight": "Lbzu0W_tagTopRight",
  "title": "Lbzu0W_title",
  "titleLink": "Lbzu0W_titleLink",
  "venue": "Lbzu0W_venue",
});
